export default function BeforeAfter() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            See The Transformation
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Real results from our landscaping projects in Joplin, Missouri
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Before */}
          <div className="relative group">
            <div className="absolute top-6 left-6 z-10">
              <span className="px-6 py-2 bg-red-600 text-white text-sm font-bold rounded-full shadow-lg">
                BEFORE
              </span>
            </div>
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <div className="w-full h-[500px]">
                <img 
                  src="https://static.readdy.ai/image/7012d1ed0225cfc4bba0161dc27b2468/e7f901decb04b6d54b37ad97aa1e0e1c.png"
                  alt="Before landscaping"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* After */}
          <div className="relative group">
            <div className="absolute top-6 left-6 z-10">
              <span className="px-6 py-2 bg-teal-600 text-white text-sm font-bold rounded-full shadow-lg">
                AFTER
              </span>
            </div>
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <div className="w-full h-[500px]">
                <img 
                  src="https://static.readdy.ai/image/7012d1ed0225cfc4bba0161dc27b2468/ca6b51449e5ef704df13f36d7bd15060.png"
                  alt="After landscaping with beautiful rock garden and plants"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            <strong>Professional landscaping</strong> that transforms your outdoor space with custom rock gardens, native plants, and expert design
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="px-10 py-4 bg-teal-600 text-white text-base font-semibold rounded-full hover:bg-teal-700 transition-all inline-flex items-center space-x-2 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <span>Start Your Transformation</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}